import { Component } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { FinoCommonModule } from '@fino-ui/common';
import { BaseModalComponent } from '@fino-ui/modal';
import { FinoTranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-approve-modal',
  templateUrl: './approve-modal.component.html',
  imports: [FinoTranslationModule, ButtonModule, FinoCommonModule],
})
export class ApproveModalComponent extends BaseModalComponent<
  { title: string; description: string },
  boolean
> {
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  title: string = '';
  description: string = '';

  submit() {
    this.result = true;
    this.close();
  }
}
